import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchExercisesArgs,
  FetchExerciseById,
} from '../api/types/exercises.types';

import { fetchExerciseById, fetchExercises } from '../api/exercises.api';

export const exercisesQueryKeys = createQueryKeys('exercises', {
  fetchExerciseById: ({
    id,
    isPart,
    locale,
    organizationId,
    skipView,
  }: FetchExerciseById) => ({
    queryFn: () =>
      fetchExerciseById({ id, isPart, locale, organizationId, skipView }),
    // No need to put locale in the queryKey, since exercise is returned with all translations, this includes tags too.
    // skipView in the key separates the name-map cache from actual views
    // (which record "recently viewed" on the BE) — otherwise the name-map
    // fetch would suppress the recording.
    queryKey: [organizationId, id, isPart, skipView],
  }),
  fetchExercises: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchExercisesArgs) => ({
    queryFn: () =>
      fetchExercises({
        contentFilters,
        locale,
        organizationId,
        tableFilters,
      }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
  fetchInfiniteExercises: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchExercisesArgs) => ({
    queryFn: async (context: any) =>
      fetchExercises({
        contentFilters,
        locale,
        organizationId,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
});
